import { format } from 'date-fns';

export const getDateFromDateString = (date: string, dateFormat: string) => {
  return format(new Date(date), dateFormat);
};
